import React from 'react';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { RMSvgIconNames } from 'components/customComponents/CommonComponents/RMSvgIcon';
import { CustomCheckBox } from 'components/input';

export interface Props {
  isChecked: boolean;
  isVisible: boolean;
  onCheckboxChange: (columnId: number) => void;
  onVisibilityChange?: (columnId: number) => void;
  columnId: number;
  columnTitle: string;
  containerClass?: string;
  labelClass?: string;
  showCheckboxBeforeTitle?: boolean;
  disabled?: boolean;
  disableVisibilityChange?: boolean;
}

const iconCLasses = {
  EyeOpen: 'bg-black',
  EyeClosed: '',
};

const LabelRowWithActions = (props: Props) => {
  const {
    isChecked,
    isVisible,
    onCheckboxChange,
    onVisibilityChange,
    columnId,
    columnTitle,
    containerClass = '',
    labelClass = '',
    disabled = false,
    disableVisibilityChange = false,
  } = props;

  const visibilityIcon: RMSvgIconNames = isVisible ? 'EyeOpen' : 'EyeClosed';

  return (
    <div
      id="labelrowwithactions-main-container"
      className={`flex justify-between ${containerClass}`}
    >
      <div id="labelrowwithactions-label" className="flex w-10/12">
        <label id="labelrowwithactions-label-text" className={`${labelClass}`}>
          {columnTitle}
        </label>
      </div>
      <div
        id="labelrowwithactions-checkbox-wrapper"
        className="flex w-2/12 gap-2 justify-end align-center"
      >
        <CustomCheckBox
          type="checkbox"
          checked={isChecked}
          onChange={() => onCheckboxChange(columnId)}
          disabled={disabled}
        />
        {onVisibilityChange && (
          <RMCustomButton
            onClick={() => onVisibilityChange(columnId)}
            iconProps={{ name: visibilityIcon, fill: 'black', width: 18, height: 18 }}
            iconClass={`border rounded-sm ${iconCLasses[visibilityIcon]} ${
              !isChecked ? 'bg-[#A0A0A0]' : 'white'
            }`}
            isDisabled={disableVisibilityChange ?? !isChecked}
          />
        )}
      </div>
    </div>
  );
};

export default LabelRowWithActions;
